<div class="card p-4 flex flex-col border border-gray-500 rounded-lg">
  <nz-skeleton [nzLoading]="loading" [nzActive]="true">
    <div class="flex flex-col">
      <div class="py-1 title">Api Key List</div>
      <span>Manage API Keys for every services that you use.</span>
    </div>
  </nz-skeleton>
  <nz-skeleton *ngIf="loading" [nzLoading]="loading" [nzActive]="true"></nz-skeleton>
  <div *ngIf="!loading" class="mt-3">
    <nz-table #basicTable [nzShowPagination]="false" [nzData]="listOfData" [nzScroll]="{ x: '1280px' }">
      <thead>
        <tr>
          <th style="width: 50px !important"></th>
          <th style="width: 250px !important">API Name</th>
          <th style="width: 350px !important">API Key</th>
          <th>Added</th>
          <th>Expires</th>
          <th>Total API HIT / Day</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of listOfData; let i = index">
          <tr [id]="'api-' + getApiLabel(data.api_name).toLowerCase().replaceAll(' ', '-')">
            <td>{{ i + 1 }}</td>
            <td>
              <div class="flex justify-between capitalize">
                {{ getApiLabel(data.api_name) }}
                <img
                  [src]="
                    isExpanded(data.api_name)
                      ? 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-down-1.svg'
                      : 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-right-2.svg'
                  "
                  alt="down"
                  class="cursor-pointer"
                  (click)="toggleExpand(data.api_name)"
                />
              </div>
            </td>
            <td>
              <!-- State 1: API Key Belum Dibuka (Locked) -->
              <div *ngIf="getApiKey(data.api_name) === ''" class="flex items-center gap-1.5">
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/eye.svg"
                  alt="show"
                  class="cursor-pointer"
                  (click)="showKey(data.api_name)"
                />
                <span
                  class="underline cursor-pointer"
                  (click)="showKey(data.api_name)"
                >
                  Show Key
                </span>
              </div>

              <!-- State 2: API Key Sudah Dibuka (Masked: bh8n4280......pbv, klik icon eye untuk hide, klik text untuk copy) -->
              <div *ngIf="getApiKey(data.api_name) !== ''" class="flex items-center gap-1.5">
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/eye-slash.svg"
                  alt="hide"
                  class="cursor-pointer"
                  (click)="hideKey(data.api_name)"
                />
                <span
                  class="text-danger underline cursor-pointer font-mono font-medium select-none"
                  (click)="copyValue(getApiKey(data.api_name))"
                  title="Klik untuk copy API Key"
                >
                  {{ getMaskedKey(data.api_name) }}
                </span>
              </div>
            </td>
            <td>{{ (data.created_at | date : "dd/MM/yyyy") || "-" }}</td>
            <td>{{ (data.expired_at | date : "dd/MM/yyyy") || "-" }}</td>
            <td>
              <div class="flex items-center gap-1">
                <span class="text-bold">{{ data.total_hit | number }}</span>/
                <ng-container *ngIf="data.api_name === 'cost'">
                  {{ data.limit | number }}
                </ng-container>
                <img
                  *ngIf="data.api_name !== 'cost'"
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/unlimited.svg"
                  alt="unlimited"
                  width="20px"
                />
              </div>
            </td>
          </tr>

          <!-- Nested Detail Rows -->
          <ng-container *ngIf="isExpanded(data.api_name)">
            <tr
              *ngFor="let details of getDetailsList(data.api_name); let detailIdx = index"
              [ngClass]="{ 'no-border': detailIdx !== getDetailsList(data.api_name).length - 1 }"
            >
              <td></td>
              <td colspan="4">
                <div class="flex items-center gap-2">
                  <div class="get py-1 px-4 rounded" [ngClass]="classMethod(details.method)">
                    {{ details.method }}
                  </div>
                  <span class="text-capitalize">
                    {{ apiName(details.name) }}
                  </span>
                </div>
              </td>
              <td>{{ details.request_count }}</td>
            </tr>
            <tr *ngIf="getDetailsList(data.api_name).length === 0">
              <td colspan="6" class="text-center">No Data</td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </nz-table>
  </div>
</div>
